import { Component, Inject, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CreditPlan, CreditPlanInterface } from 'src/app/model/credit-plan';
import { FormControlDefinition } from 'src/app/model/form-control-definition';

@Component({
  selector: 'app-edit-credit-plan-dialog',
  templateUrl: './edit-credit-plan-dialog.component.html',
  styleUrl: './edit-credit-plan-dialog.component.scss'
})
export class EditCreditPlanDialogComponent {
  /** Form group for validation */
  public formGroup: FormGroup = new FormGroup({
    active: new FormControl('', CreditPlan.Validators.get("active")),
    name: new FormControl('', CreditPlan.Validators.get("name")),
    apr: new FormControl('', CreditPlan.Validators.get("apr")),
    duration: new FormControl('', CreditPlan.Validators.get("duration")),
    mdr: new FormControl('', CreditPlan.Validators.get("mdr")),
    supplierId: new FormControl('', CreditPlan.Validators.get("supplier")),
    notes: new FormControl('', CreditPlan.Validators.get("notes")),
    description: new FormControl('', CreditPlan.Validators.get("description")),
  });

  /** The form to render */
  public form: FormControlDefinition[] = [
    {
      title: "Active",
      name: "active",
      type: "slide",
      placeholder: "",
      control: this.formGroup.controls["active"],
      editable: true,
    },
    {
      title: "Plan Name",
      name: "name",
      type: "text",
      placeholder: "",
      control: this.formGroup.controls["name"],
      editable: true,
    },
    {
      title: "APR",
      name: "apr",
      type: "number",
      placeholder: "Enter APR",
      control: this.formGroup.controls["apr"],
      editable: true,
    },
    {
      title: "Duration",
      name: "duration",
      type: "number",
      placeholder: "Enter Duration",
      control: this.formGroup.controls["duration"],
      editable: true,
    },
    {
      title: "MDR",
      name: "mdr",
      type: "number",
      placeholder: "Enter MDR",
      control: this.formGroup.controls["mdr"],
      editable: true,
    },
    {
      title: "Supplier",
      name: "supplierId",
      type: "number",
      placeholder: "Enter Supplier ID",
      control: this.formGroup.controls["supplierId"],
      editable: true,
    },
    {
      title: "Short Plan Description (Notes)",
      name: "notes",
      type: "textarea",
      placeholder: "Enter Notes",
      control: this.formGroup.controls["notes"],
      editable: true,
    },
    {
      title: "Long Plan Description (Description)",
      name: "description",
      type: "textarea",
      placeholder: "Enter Description",
      control: this.formGroup.controls["description"],
      editable: true,
    },
  ];

  /** Notes for the update */
  public updateNotes: string = "";

  /**
   * Default constructor initializes the component with a dialog ref
   * @param dialogRef
   */
  constructor(
    public dialogRef: MatDialogRef<EditCreditPlanDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {creditPlan: CreditPlan},
  ) {
    const creditPlan = this.data?.creditPlan.copyOf();

    if (creditPlan == undefined) {
      this.cancel();
      return;
    }

    this.formGroup.setValue({
      active: creditPlan.active,
      name: creditPlan.name,
      apr: creditPlan.apr,
      duration: creditPlan.duration,
      mdr: creditPlan.mdr,
      supplierId: creditPlan.supplier,
      notes: creditPlan.notes,
      description: creditPlan.description,
    });
  }

  /**
   * Cancel any changes and close the dialog
   */
  public cancel() {
    this.dialogRef.close(null);
  }

  /**
   * Save the changes to a new credit plan and close the dialog
   */
  public save() {
    // Get the raw data from the form and convert necessary fields
    const raw: any = this.formGroup.getRawValue();

    // Create the credit plan interface and close the dialog (convert to credit plan first to trim fields)
    const intf: CreditPlanInterface = raw as CreditPlanInterface;
    const creditPlan = new CreditPlan(intf);
    this.dialogRef.close({
      intf: creditPlan.asInterface(),
      updateNotes: this.updateNotes,
    });
  }
}
